<template>
  <div class="bg">
    <div class="content" id="pdfDom">
      <p class="historyBack">
        <el-button type="primary" size='small' icon="el-icon-d-arrow-left" @click="routerBack()">返回</el-button>
      </p>
      <div class="page-header">
        <div class="patentData-name">{{patentData.name}}<el-tag size="small" :type="tagType">{{patentData.law_status}}</el-tag></div>
        <div class="operation-group">
          <el-button type="text" icon="el-icon-star-off" @click="collect()">收藏专利</el-button>
          <el-button type="text" icon="el-icon-download" @click="down()">导出专利</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <div class="main my-scrollbar">
            <el-row class="info">
              <div class="text-info">
                <div class="text-info-item" v-for="(item,index) in attribute" :key="index">
                  <div class="attribute-name">{{item.label}}：</div>
                  <div class="attribute-value">{{patentData[item.name]}}</div>
                </div>
              </div>
              <div class="image-info">
                <div style="color: #959595; font-weight: bold; margin: 0 0 32px 40px;">专利图片：</div>
                <div class="image-container" v-for="(item,index) in patentData.description_image_array" :key="index">
                  <el-image :src="'http://co.nercdh.cn:3388'+item" :fit=" 'contain' " :preview-src-list="srcList"
                  style="width:144px; height:144px">
                    <div slot="placeholder" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <span>{{item.describe}}</span>
                </div>
              </div>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="法律状态" name="second">
          <div class="main">
            <el-row class="info">
              <p style="text-align:center;color:#606266;font-size:15px">暂无内容</p>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="专利原文" name="third">
          <div class="main">
            <el-row class="info">
              <iframe class="iframe-info" :src="patentData.iframeSrc" frameborder="0"></iframe> 
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="引证信息" name="fourth">
          <div class="main">
            <el-row class="info">
              <p style="text-align:center;color:#606266;font-size:15px">暂无内容</p>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import html2Canvas from 'html2canvas'
  import JsPDF from 'jspdf'
  import { detailInfo } from "@/api/patent.js";
  export default {
    name: 'information',
    data() {
      return {
        id:'',
        activeName: "first",
        tagType: "",
        attribute: [
          {
            name: 'abstract',
            label: '简要说明'
          },
          {
            name: 'apply_num',
            label: '申请号'
          },
          {
            name: 'publish_num',
            label: '公开号'
          },
          {
            name: 'class_num',
            label: '洛迦诺分类号'
          },
          {
            name: 'apply_date',
            label: '申请日期'
          },
          {
            name: 'publish_date',
            label: '公开日期'
          },
          {
            name: 'invent_people',
            label: '设计人'
          },
          {
            name: 'apply_people',
            label: '申请人'
          },
          {
            name: 'apply_address',
            label: '申请地址'
          },
          {
            name: 'patent_people',
            label: '专利权人'
          },
          {
            name: 'law_status',
            label: '法律状态'
          },
          {
            name: 'agent_people',
            label: '代理人'
          },
          {
            name: 'agent_org',
            label: '代理机构'
          }
        ],
        srcList: [],
        patentData: {}
      }
    },
    mounted: function () {
      let params=this.$route.params;
      if(params.id){
        this.id=parseInt(params.id)
        this.getDetailedInfo();
      }
    },
    methods: {
      async getDetailedInfo() {
        let params={
          id:this.id
        }
        let res=await detailInfo(params);
        if(res.errno == 0){
          this.patentData = res.data;
          this.tagTape();
          this.getSrcList();
        }else{
          this.$message.error(res.errmsg);
        }
      },
      tagTape() {
        if(this.patentData.law_status === "无效"){
          this.tagType = "info";
        }
      },
      getSrcList() {
        for (let i=0; i < this.patentData.description_image_array.length; i++) {
          this.srcList.push('http://co.nercdh.cn:3388'+this.patentData.description_image_array[i]); 
        }
      },
      routerBack(){
        this.$router.go(-1)
      },
      collect(){
        this.$message({
            message: '专利收藏成功',
            type: 'success'
          });
      },
      down () {
        var title = this.patentData.name;
        html2Canvas(document.querySelector('#pdfDom'), {
          allowTaint: true
        }).then(function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28
          let imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
        }
        )
      }
    }
  }
</script>

<style scoped>
  .bg {
    background-color: #f7faff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .content{
    width: 100%;
    max-width: 1980px;
    height: calc(100vh - 48px);
    flex-direction: column;
  }

  .page-header {
    height: 70px;
    width: 100%;
  }
  .patentData-name {
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    margin-top: 20px;
    float: left;
    text-align: center;
  }
  .operation-group {
    margin-top: 15px;
    right: 60px;
    position: absolute; 
    z-index:999;
  }

  ::v-deep .el-tabs {
    height: calc(100% - 70px);
  }
  ::v-deep .el-tabs .el-tabs__header {
    margin: 0;
  }
  ::v-deep .el-tabs .el-tabs__nav-scroll{
    display: flex;
    flex-direction: column;
  }
  ::v-deep .el-tabs .el-tabs__nav {
    margin: 0 auto;
    align-self: center;
  }

  ::v-deep .el-tabs .el-tabs__content {
    height: calc(100% - 40px);
    background-color: #FFFFFF;
  }
  ::v-deep .el-tabs .el-tab-pane {
    height: 100%;
  }

  .main {
    overflow: auto;
    width: calc(100% - 5px);
    margin-right: 5px;
    height: calc(100% - 1px);
    border-bottom: 1px solid #e5e6eb;
  }

  .info {
    width: cacl(100% - 300px);
    padding: 4px 150px 50px 150px;
    display: flex;
  }
  .text-info {
    width: 70%;
    float: left;
    padding: 30px 40px 0 0;
  }
  .text-info-item {
    padding: 10px 0 10px 0;
    margin: 0 60px 0 60px;
    border-bottom: 1px dashed #e5e6eb;
  }
  .attribute-name{
    display: inline-block;
    vertical-align: top;
    width: 120px;
    text-align: right;
    padding-right: 30px;
    color: #959595;
    font-weight: bold;
    font-size: 14px;
  }
  .attribute-value{
    display: inline-block;
    vertical-align: top;
    line-height: 150%;
    width: calc(100% - 155px);
    font-size: 14px;
  }

  .image-info {
    width: 30%;
    height: 100%;
    float: right;
    border-left: 1px solid #e5e6eb;
    margin-top: 40px;
    padding-left: 20px;
  }
  .image-container {
    width: 144px;
    height: 144px;
    display: inline-block;
    margin: 0 0 40px 40px;
    text-align: center;
  }
  .image-container span {
    font-size: 14px;
    color: #959595;
  }
  .historyBack{
      margin: 0px 40px;
      color: #1287C9;
      cursor: pointer;
  }
  .iframe-info{
    width:100%;
    height:calc(100vh - 250px);
  }
</style>
